var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainPage from "../pages/MainPage";
import BlogPageWrapper from "../admin/blog/BlogPageWrapper";
import { OverflowContainer } from "../assets/styles/mainPageStyles"; // Импортируем обертку
// Ленивая загрузка страниц, чтобы тяжёлые зависимости (react-admin, MUI и т.д.)
// не попадали в первый бандл лендинга
var NotFoundPage = React.lazy(function () { return import("../pages/NotFoundPage"); });
var NavigationPage = React.lazy(function () { return import("../pages/NavigationPage"); });
var AdminPanel = React.lazy(function () { return import("../pages/AdminPanel"); });
var BlogPage = React.lazy(function () { return import("../pages/BlogPage"); });
var BlogPostPage = React.lazy(function () { return import("../pages/BlogPostPage"); });
var AppRouter = function (_a) {
    var currentLocale = _a.currentLocale, onLocaleChange = _a.onLocaleChange;
    return (_jsx(BrowserRouter, { children: _jsx(Suspense, __assign({ fallback: null }, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(MainPage, { currentLocale: currentLocale, onLocaleChange: onLocaleChange }) }), _jsx(Route, { path: "/navigation", element: _jsx(NavigationPage, {}) }), _jsx(Route, { path: "/blog", element: _jsx(OverflowContainer, { children: _jsx(BlogPageWrapper, { children: _jsx(BlogPage, { currentLocale: currentLocale, onLocaleChange: onLocaleChange }) }) }) }), _jsx(Route, { path: "/blog/post/:id", element: _jsx(BlogPageWrapper, { children: _jsx(BlogPostPage, { currentLocale: currentLocale, onLocaleChange: onLocaleChange }) }) }), _jsx(Route, { path: "/admin/*", element: _jsx(AdminPanel, {}) }), _jsx(Route, { path: "*", element: _jsx(NotFoundPage, { currentLocale: currentLocale, onLocaleChange: onLocaleChange }) })] }) })) }));
};
export default AppRouter;
